import type { CompanyListItem } from '@planuze/admin-contracts';
import { Button, Input, Popover, PopoverContent, PopoverTrigger } from '@planuze/ui';
import { useState } from 'react';
import { usePlansContent } from '../../content/sections/plans.js';
import { useCompaniesList } from '../../hooks/use-companies.js';
import { useDebounce } from '../../hooks/use-debounce.js';

interface Props {
  readonly value: CompanyListItem | null;
  readonly onChange: (org: CompanyListItem) => void;
}

/* Autocomplete de organização (alvo de plano privado). Filtra `status: 'active'` —
   não se cria plano para empresa bloqueada (armadilha do esboço). */
export function OrgPicker({ value, onChange }: Props) {
  const copy = usePlansContent();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const debounced = useDebounce(query, 250);
  const { data } = useCompaniesList({
    search: debounced.length >= 2 ? debounced : undefined,
    status: 'active',
  });
  const items = data?.pages.flatMap((page) => page.items) ?? [];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" type="button" className="w-full justify-start">
          {value !== null ? value.name : copy.orgPicker.selectPlaceholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2">
        <Input
          value={query}
          placeholder={copy.orgPicker.searchPlaceholder}
          aria-label={copy.orgPicker.searchAriaLabel}
          onChange={(e) => setQuery(e.target.value)}
        />
        <ul className="mt-2 max-h-60 overflow-auto">
          {items.map((org) => (
            <li key={org.id}>
              <button
                type="button"
                className="w-full rounded-md px-2 py-1.5 text-left text-sm hover:bg-accent/15"
                onClick={() => {
                  onChange(org);
                  setOpen(false);
                }}
              >
                {org.name}
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
